export type Period = "week" | "month" | "overdue" | "all";

export type TaskFilters = {
  period: Period;
  startDate: string;
  endDate: string;
  priority: string;
  status: string;
  assigneeId: string;
  createdById: string;
  view?: string;
};

// Skips keys with empty / undefined / null values
export function buildUrl(base: string, params: Record<string, string | undefined>): string {
  const qs = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v) qs.set(k, v);
  });
  const s = qs.toString();
  return s ? `${base}?${s}` : base;
}

export function toISODate(d: Date): string {
  return d.toISOString().split("T")[0];
}

export function getWeekRange() {
  const today = new Date();
  const day = today.getDay();
  const monday = new Date(today);
  monday.setDate(today.getDate() - (day === 0 ? 6 : day - 1));
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);
  return { startDate: toISODate(monday), endDate: toISODate(sunday) };
}

export function getMonthRange() {
  const today = new Date();
  const first = new Date(today.getFullYear(), today.getMonth(), 1);
  const last = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  return { startDate: toISODate(first), endDate: toISODate(last) };
}

export function dateRangeForPeriod(period: Period) {
  if (period === "week") return getWeekRange();
  if (period === "month") return getMonthRange();
  return { startDate: "", endDate: "" };
}

export type TaskPagination = {
  page?: number;
  perPage?: number;
};

// Maps UI filter state to API query params.
// To add a new filter: add a field to TaskFilters, add one line here.
export function toQueryParams(
  search: string,
  f: TaskFilters,
  pagination?: TaskPagination
): Record<string, string | undefined> {
  return {
    search: search.trim() || undefined,
    startDate: f.period !== "overdue" ? (f.startDate || undefined) : undefined,
    endDate: f.period !== "overdue" ? (f.endDate || undefined) : undefined,
    overdue: f.period === "overdue" ? "true" : undefined,
    priority: f.priority || undefined,
    status: f.status || undefined,
    assigneeId: f.assigneeId || undefined,
    createdById: f.createdById || undefined,
    view: f.view || undefined,
    page: pagination?.page !== undefined ? String(pagination.page) : undefined,
    perPage: pagination?.perPage !== undefined ? String(pagination.perPage) : undefined,
  };
}
